import { render, staticRenderFns } from "./CustomFields.vue?vue&type=template&id=a8ae80f2"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports